import {
  PromocodePasswordFormValues,
  PromocodePasswordFormViolation,
} from 'types/promocodePasswordFormTypes';

export const createPromocodePasswordFormValues = (): PromocodePasswordFormValues => ({
  password: '',
});

export const validatePromocodePasswordFormValues = (
  values: PromocodePasswordFormValues
): PromocodePasswordFormViolation[] => {
  const violations: PromocodePasswordFormViolation[] = [];

  if (!values.password) {
    violations.push({
      name: 'PasswordIsMissed',
    });
  }

  return violations;
};

export const createPromocodePasswordFormViolationLense = (
  violation: PromocodePasswordFormViolation
) => ({
  isPasswordViolation() {
    switch (violation.name) {
      case 'PasswordIsMissed':
        return true;
      default:
        return false;
    }
  },
});
